import { MessageRef } from "@/types/chat"
import { CollectionRef } from "@/types/collection"
import { CreatorWaitlisterStatus } from "@/types/creator"
import { EntityRef } from "@/types/entity"
import { TripRef } from "@/types/trip"
import {
  UpdateUserProfileResults,
  UserProfileUpdates,
  UserRef,
} from "@/types/user"

import { BaseApi } from "@/lib/base-api"

type FormStatus = "success" | "error" | "servering" | "not-started"

export class CreatorApi extends BaseApi {
  async addCreatorWaitlister(): Promise<{ status: FormStatus }> {
    return await this.post<{ status: FormStatus }>(`api/creator/add`)
  }

  async getCreatorWaitlisterStatus(): Promise<CreatorWaitlisterStatus> {
    return await this.get<CreatorWaitlisterStatus>(`api/creator/status`)
  }

  async joinCreatorProgram(
    userProfileDTO: UserProfileUpdates
  ): Promise<UpdateUserProfileResults> {
    return await this.post(`/api/creator/join`, {
      user_profile: userProfileDTO,
    })
  }

  async attributeToPartner(
    userRef: UserRef,
    objectRef?: EntityRef | MessageRef | TripRef | CollectionRef
  ): Promise<{ status: FormStatus; msg: string; url: string }> {
    const payload: {
      referrer: UserRef
      entityRef?: EntityRef | MessageRef | TripRef | CollectionRef
    } = {
      referrer: userRef,
    }
    if (objectRef) {
      payload.entityRef = objectRef
    }
    return await this.post<{ status: FormStatus; msg: string; url: string }>(
      `api/creator/attribute`,
      payload
    )
  }
}
